module.exports = __webpack_public_path__ + "img/precheckBgRed.e9b87a8.jpg";